<template>
  <v-card
    class="pa-6 elevation-0"
    min-width="300px"
    max-width="450px"
  >
    <v-row class="align-center pa-2">
      <v-col>
        <v-card-title class="pa-0 subtitle-1 font-weight-bold">
          Quick Links
        </v-card-title>
        <v-card-subtitle class="pa-0 mt-0">
          {{ subtitle }}
        </v-card-subtitle>
      </v-col>
    </v-row>

    <v-row class="align-center mb-2">
      <v-col class="py-0">
        <v-row dense>
          <v-col
            v-for="action in nextActions"
            :key="action.key"
            cols="12"
            sm="6"
            class="py-1"
          >
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  small
                  text
                  class="text-none w-100"
                  :to="action.to"
                  v-bind="attrs"
                  v-on="on"
                >
                  <font-awesome-icon
                    :icon="action.icon"
                    size="xs"
                    class="mr-1"
                  />
                  <span
                    class="caption"
                    style="font-size: 0.8rem"
                  >
                    {{ action.label }}
                  </span>
                </v-btn>
              </template>
              <span class="caption">{{ action.helpText }}</span>
            </v-tooltip>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'

const { mapGetters } = createNamespacedHelpers('auth')

export default {
  name: 'OnboardingCard',

  data() {
    return {}
  },

  computed: {
    ...mapGetters([
      'isInternalUser',
      'isUserInternalAdmin',
      'userEmail',
    ]),

    subtitle() {
      if (this.isUserInternalAdmin) {
        return 'Your high-impact workflows.'
      }

      if (this.isInternalUser) {
        return 'Jump to common routes.'
      }

      return 'Jump into your favorite reports.'
    },

    nextActions() {
      const docAction = {
        key: 'docs',
        label: 'Docs',
        to: '/docs/getting-started',
        icon: ['fas', 'book-open'],
        helpText: 'Read release notes and product guidance.',
      }

      const baseActions = [
        {
          key: 'projects',
          label: 'Projects',
          to: '/internal/projects',
          icon: ['fas', 'folder-open'],
          helpText: 'Review project status, tabs, and filters in one place.',
        },
        {
          key: 'time',
          label: 'Time',
          to: '/internal/time',
          icon: ['fas', 'clock'],
          helpText: 'Track and review time entries by tab and date range.',
        },
        docAction,
      ]

      if (!this.isInternalUser) {
        return [
          {
            key: 'reports',
            label: 'Reports',
            to: '/reports/pacing',
            icon: ['fas', 'chart-line'],
            helpText: 'Start with your primary report workflow.',
          },
          docAction,
        ]
      }

      if (this.isUserInternalAdmin) {
        return [
          ...baseActions,
          {
            key: 'admin-projects',
            label: 'Admin Projects',
            to: '/admin/projects',
            icon: ['fas', 'user-shield'],
            helpText: 'Manage project edits, linking, and admin workflows.',
          },
        ]
      }

      return baseActions
    },
  },

  methods: {},
}
</script>
